import Vue from 'vue'
import { StylesParser } from '../StylesParser'
import { ConstantsParser } from '../ConstantsParser'
export class HeaderBuilder {
  constructor(header) {
    this.header = header
    console.log(this.header)
  }

  build() {
    this.buildClasses()
    this.buildIds()
    this.buildStyles()
    let header = this.buildHeader()
    return header

  }

  buildIds() {
    this.ids = {
      id: this.header.id,
      ctaId: this.header.ctaId,
      logoId: this.header.logoId,
      containerId: this.header.containerId,
    }
  }

  buildStyles() {
    this.styles = [
      {id: 'containerId', element: 'id', styles: 'styles', selector: '#', variation: null},
      {id: 'ctaId', element: 'id', styles: 'ctaStyles', selector: '#', variation: null},
      {id: 'ctaId', element: 'id', styles: 'hoverCtaStyles', selector: '#', suffix: ':hover'},
      {element: 'class', styles: 'hoverNavLinkStyles', selector: '.wf-header-nav-link', suffix: ':hover'},
      {element: 'class', styles: 'megaMenuContainerStyles', selector: '.wf-header-mega-menu-container'},
      {element: 'class', styles: 'megaMenuStyles', selector: '.wf-header-mega-menu'},
      {element: 'class', styles: 'megaMenuTitleStyles', selector: '.wf-header-mega-menu-title'},
      {element: 'class', styles: 'navLinkStyles', selector: '.wf-header-nav-link'},
      {element: 'class', styles: 'subMenuContainerStyles', selector: '.wf-header-sub-menu-container'},
      { element: 'class', styles: 'subMenuStyles', selector: '.wf-header-sub-menu' },
    ] 

    console.log(this.header.megaMenuContainerStyles)
    this.styles.forEach(elementId => {
      let styles = {}
      if (elementId.element == 'id') {
        Vue.set(styles, 'id', `${elementId.selector}${this.ids[elementId.id]}`)
      }
      if (elementId.element == 'class') {
        Vue.set(styles, 'id', `${elementId.selector}${elementId.suffix ? elementId.suffix : ''}`)
      }
      Vue.set(styles, elementId.styles, {})
      Vue.set(styles[elementId.styles], 'desktop', (new StylesParser(this.header[elementId.styles], 'desktop')).parse())
      Vue.set(styles[elementId.styles], 'tablet', (new StylesParser(this.header[elementId.styles], 'tablet')).parse())
      Vue.set(styles[elementId.styles], 'phone', (new StylesParser(this.header[elementId.styles], 'phone')).parse())
      window.StylesBuilder.add(styles)
    })
  }

  buildClasses() {
    this.classes = {
      classes: (new ConstantsParser(this.header.classes)).parseResponsiveClasses().join(' '),
      containerClasses: (new ConstantsParser(this.header.containerClasses)).parseResponsiveClasses().join(' '),
      containerNavLinkClasses: (new ConstantsParser(this.header.containerNavLinkClasses)).parseResponsiveClasses().join(' '),
      ctaClasses: (new ConstantsParser(this.header.ctaClasses)).parseResponsiveClasses().join(' '),
      megaMenuClasses: (new ConstantsParser(this.header.megaMenuClasses)).parseResponsiveClasses().join(' '),
      megaMenuContainerClasses: (new ConstantsParser(this.header.megaMenuContainerClasses)).parseResponsiveClasses().join(' '),
      megaMenuTitleClasses: (new ConstantsParser(this.header.megaMenuTitleClasses)).parseResponsiveClasses().join(' '),
      navLinkClasses: (new ConstantsParser(this.header.navLinkClasses)).parseResponsiveClasses().join(' '),
      subMenuClasses: (new ConstantsParser(this.header.subMenuClasses)).parseResponsiveClasses().join(' '),
      subMenuContainerClasses: (new ConstantsParser(this.header.subMenuContainerClasses)).parseResponsiveClasses().join(' '),
    }
  }

  buildHeader() {
    return `<div class="${this.classes.containerClasses}" id="${this.ids.containerId}">
      <wfs-header type="${this.headerType()}" id="${this.ids.id}" class="${this.classes.classes}">
        ${this.buildLogo()}
        ${this.buildNavLinks()}
        ${this.buildCta()}
      </wfs-header>
    </div>`
  }

  headerType() {
    return ({
      DEFAULT: 'default',
      LEFT: 'left',
      CENTER: 'center',
      SPLIT: 'split',
      HAMBUERGER: 'hamburger'
    })[this.header.content.type]
  }

  buildLogo() {
    return `<template v-slot:logo>
      <img
        id="${this.ids.logoId}"
        src="https://storage.googleapis.com/wfs/images/logo-01.png"
        alt=""
        class="wf-h-12"
      />
    </template>`
  }

  buildNavLinks() {
    return `<template v-slot:links>
      <ul class="wf-flex ${this.classes.containerNavLinkClasses}">
        ${this.header.content.navLinks.map(navLink => this.buildNavLink(navLink)).join('')}
      </ul>
    </template>`
  }

  buildNavLink(link, isChild = false) {
    return `<wfs-header-nav-link href="${link.link}" target="${link.target}" class="${! isChild ? 'wf-header-nav-link' : ''} ${this.classes.navLinkClasses}">
      <template v-slot:link-text>${link.text}</template>
      ${this.buildNavLinkChildren(link.children)}
    </wfs-header-nav-link>`
  }

  buildNavLinkChildren(children) {
    if (! children.length) {
      return ''
    }
    return `<template v-slot:menu>
      ${this.buildMenuContent(children)}
    </template>`
  }

  buildMenuContent(children) {
    if (children.some(child => child.children.length)) {
      return this.buildMegaMenu(children)
    }
    return this.buildSubMenu(children)
  }

  buildMegaMenu(children) {
    return `<div class="wf-header-mega-menu-container wf-absolute wf-flex ${this.menuPosition()} ${this.classes.megaMenuContainerClasses}">
      ${children.map(child => this.buildMegaMenuColumn(child)).join('')}
    </div>`
  }

  menuPosition() {
    if (this.header.content.type === 'DEFAULT') {
      return 'wf-right-0'
    }
    return 'wf-left-0'
  }

  buildMegaMenuColumn(child) {
    return `<div class="wf-flex-1">
      <ul class="wf-header-mega-menu ${this.classes.megaMenuClasses}">
        <li>
          <h3 class="wf-header-mega-menu-title">${child.text}</h3>
        </li>
        ${child.children.map(grandchild => this.buildNavLink(grandchild, true)).join('')}
      </ul>
    </div>`
  }

  buildSubMenu(children) {
    return `<div class="wf-header-sub-menu-container wf-absolute ${this.menuPosition()} ${this.classes.subMenuContainerClasses}">
      <ul class="${this.classes.subMenuClasses}">
        ${children.map(child => this.buildNavLink(child, true)).join('')}
      </ul>
    </div>`
  }

  buildCta() {
    if (! this.header.content.hasCTA) {
      return ''
    }
    return `<template v-slot:cta>
      <a href="${this.header.content.ctaLink}" class="${this.classes.ctaClasses}" id="${this.ids.ctaId}">${this.header.content.ctaText}</a>
    </template>`
  }
}